import { mixins, styled, theme } from 'ui/theme';

export const Score = {
  Alert: styled.div`
    ${mixins.baseFont};
    background: ${theme.colors.status.alert.alt};
    border-radius: ${theme.radii.small};
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.space[2]};
    padding: ${theme.space[4]};
    width: 100%;
  `,

  Title: styled.span`
    color: ${theme.colors.build.darkLight};
    font-size: ${theme.fontSizes.lg};
    margin-bottom: ${theme.space[3]};
  `,

  Description: styled.span`
    color: ${theme.colors.build.darkLight};
    font-size: ${theme.fontSizes.md};
    margin-bottom: ${theme.space[0]};
  `,

  Component: styled.div`
    padding: 0 ${theme.space[4]}};
    width: 100%;
  `,

  Content: styled.div`
    ${mixins.baseFont};
    align-items: center;
    color: ${theme.colors.build.darkLight};
    display: flex;
    font-size: ${theme.fontSizes.md};
    justify-content: space-between;
    margin: ${theme.space[2]} 0 0;
    min-width: 250px;
    width: 100%;

    &[data-spacing-top='none'] {
      margin-top: ${theme.space[0]};
    }
  `,

  Info: styled.span`
    align-items: center;
    display: flex;
    font-size: ${theme.fontSizes.md};
  `,

  TotalValue: styled.span`
    ${mixins.baseFontHeading};
    font-size: ${theme.fontSizes.lg};
    color: ${theme.colors.build.darkLight};
  `,
};
